import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import ChartConfig, { tooltipStyle } from 'Constants/chart-config';

import {  
  mskVisualisationDetails
} from 'Actions';

class balanceComponent extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  render() {

    const { visualisationdetails, loading} = this.props;
    let balancelist= visualisationdetails.balance; 
    
    const data=balancelist.map((assmntval) => {  
          return {              
              name: assmntval.assessment,
              righteyeopen: assmntval.righteyeopen,
              lefteyeopen: assmntval.lefteyeopen,
              righteyeclosed: assmntval.righteyeclosed,
              lefteyeclosed: assmntval.lefteyeclosed,
          }
    }); 
    return (
      
      <ResponsiveContainer width={this.props.data} height={400}>         
        <BarChart data={data}>
          <XAxis dataKey="name" stroke={ChartConfig.axesColor} />
          <YAxis stroke={ChartConfig.axesColor} domain={[0, 'dataMax + 5']} />
          <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
          <Tooltip wrapperStyle={tooltipStyle} cursor={false} />
          <Legend />
          <Bar dataKey="righteyeopen" name="Right Leg Eyes Open" fill={ChartConfig.color.leftshER} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="lefteyeopen" name="Left Leg Eyes Open" fill={ChartConfig.color.hipgreen} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="righteyeclosed" name="Right Leg Eyes Closed" fill={ChartConfig.color.leftshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="lefteyeclosed" name="Left Leg Eyes Closed" fill={ChartConfig.color.rightshIR} label={{ position: "top" }} barSize={20}/>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

const mapStateToProps = ({ mskvisualisation }) => {
  const { visualisationdetails, loading } = mskvisualisation;
return { visualisationdetails, loading };
}

export default connect(mapStateToProps, {
  mskVisualisationDetails
})(balanceComponent); 